import Immutable from 'immutable';
import {
  Comment,
  CommentList,
  RawComment,
  RawCommentResponse,
  RawDeleteCommentResponse,
  RawEditCommentResponse,
} from 'records/Comment';
import GQLRequest from 'utils/GQLRequest';

export const commentsForIssue = async (
  issueid: string
): Promise<CommentList> => {
  const resp = await new GQLRequest()
    .query(
      `
      query CommentsForIssue($issueid: String!) {
        commentsForIssue(issueid: $issueid) {
          cursor
          comments {
            id
            issueid
            projectid
            comment
            clientmodifiedtimestamp
            user {
              id
              email
            }
            date
          }
        }
      }
      `
    )
    .variables({ issueid })
    .json<{ commentsForIssue: RawCommentResponse }>();

  return Immutable.List(
    resp.commentsForIssue.comments.map(Comment.deserialize)
  );
};

export const addComment = async (
  issueid: string,
  projectid: string,
  comment: string,
  date: number
): Promise<Comment> => {
  const newComment = {
    issueid,
    projectid,
    comment,
    date,
    clientcreatedtimestamp: date,
  };

  const resp = await new GQLRequest()
    .query(
      `
      mutation AddComment($input: NewComment!) {
        addComment(input: $input) {
          id
          issueid
          projectid
          comment
          user {
            id
            email
          }
          date
        }
      }
      `
    )
    .variables({ input: newComment })
    .json<{ addComment: RawComment }>();

  return Comment.deserialize(resp.addComment);
};

export const deleteComment = async (
  commentid: string,
  issueid: string,
  projectid: string,
  date: number
): Promise<Comment> => {
  const input = {
    commentid,
    issueid,
    projectid,
    clientcreatedtimestamp: date,
  };

  const { deleteComment: deleteCommentResponse } = await new GQLRequest()
    .query(
      `
      mutation DeleteComment($input: DeleteComment!) {
        deleteComment(input: $input) {
          successful
          comment {
            id
            issueid
            projectid
            comment
            user {
              id
              email
            }
            date
          }
        }
      }
      `
    )
    .variables({ input })
    .json<{ deleteComment: RawDeleteCommentResponse }>();

  return Comment.deserialize(deleteCommentResponse.comment);
};

export const editComment = async (
  commentid: string,
  comment: string,
  issueid: string,
  projectid: string,
  date: number
): Promise<Comment> => {
  const input = {
    commentid,
    issueid,
    projectid,
    comment,
    clientcreatedtimestamp: date,
  };

  const { editComment: editCommentResponse } = await new GQLRequest()
    .query(
      `
      mutation EditComment($input: EditComment!) {
        editComment(input: $input) {
          comment {
            id
            issueid
            projectid
            comment
            clientmodifiedtimestamp
            user {
              id
              email
            }
            date
          }
        }
      }
      `
    )
    .variables({ input })
    .json<{ editComment: RawEditCommentResponse }>();

  return Comment.deserialize(editCommentResponse.comment);
};
